import { AppFullAccess } from '@klp/core/app/config';
import { IconName } from '@klp/design/Illustrations';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klpkonsern/routing';

declare global {
    interface AppConfigParameters {
        WEBAPP_REPORTMAPPING_ENABLE: boolean;
    }
}

export const reportMappingDocumentationPageId = '3358490627';
export const reportMappingModuleName = 'reportmapping';
export const reportMappingApiName = 'eos/reportmapping';

export const reportMappingReport = 'report';
export const reportMappingKunde = 'kunde';
export const reportMappingBygg = 'bygg';
export const reportMappingReportType = 'reporttype';

export const reportMappingRoutes = {
    moduleRoute: () => generateRoute([reportMappingModuleName]),
    documentationRoute: () =>
        generateRoute([reportMappingModuleName, 'documentation']),
};

export const ReportMappingMenuItems = [
    new SidebarMenuItem({
        route: reportMappingRoutes.moduleRoute(),
        matchRoute: reportMappingRoutes.moduleRoute(),
        icon: IconName.TRANSFER,
        translation: 'reportMapping.menu.title',
        access: AppFullAccess,
    }),
];
